import {
  TGDDesign, TGDInitialState, TGraphicDesignLessonConfig,
} from '../../../models/courses/graphicDesign';
import { TGDWorkspace } from '../core/workspace';
import { TGDAnswers } from '../core/rules';
import { deriveCritiqueConfig } from './critique';

export const resolveStartDesign = (initialState: TGDInitialState | undefined,
  fromLesson: TGDWorkspace | null, background: string): TGDDesign => {
  if (initialState?.mode === 'inline') return initialState.design;
  if (initialState?.mode === 'fromLesson') return fromLesson?.design ?? initialState.fallback;
  return { background, components: [] };
};

export const capStars = (stars: 0 | 1 | 2 | 3, hintsUsed: number,
  firstTryWrong = false): 0 | 1 | 2 | 3 =>
  (hintsUsed >= 3 || firstTryWrong) && stars === 3 ? 2 : stars;

export const activeTimeMs = (savedMs: number, visibleSince: number | null,
  now: number, completed: boolean): number => completed ? savedMs
    : savedMs + (visibleSince === null ? 0 : Math.max(0, now - visibleSince));

/**
 * Une lecon sans regle obligatoire serait gagnee des l'ouverture : on ne
 * lance le lecteur que si au moins une regle requise existe (zones derivees
 * comprises pour la critique).
 */
export const isLessonPlayable = (config: TGraphicDesignLessonConfig): boolean => {
  const effective = config.exerciseType === 'CRITIQUE' ? deriveCritiqueConfig(config) : config;
  return effective.rules.some(rule => rule.tier === 'required');
};

/** Efface les reponses en gardant la penalite d'une premiere reponse fausse. */
export const resetAnswers = (answers: TGDAnswers): TGDAnswers =>
  answers.firstTryWrong ? { firstTryWrong: true } : {};
